export default [{
	titulo: 'Planejamento Saúde',
	icone: 'menu-icon fa fa-caret-right',
	url: '/links/planejamento-saude',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]